function startTouchFN(e) {
    e.currentTarget.classList.add("touch-start");
    e.currentTarget.classList.remove("touch-end");
}

function endTouchFN(e) {
    e.currentTarget.classList.add("touch-end");
    e.currentTarget.classList.remove("touch-start");
}

const cbox = document.querySelectorAll(".touch");

for (let i = 0; i < cbox.length; i++) {
    cbox[i].addEventListener("touchstart", startTouchFN);
    cbox[i].addEventListener("touchend", endTouchFN);
}
